import React from 'react';
import Portal from '@spothero/ui/portal';

const FullPageLoader = props => {
    return (
        <Portal>
            <div className="shim" />
            <div className="FullPageLoader">
                <div className="content">
                    <div className="graphic" />
                    <span>Things are happening.</span>
                    <small>This could take a few seconds...</small>
                </div>
            </div>
        </Portal>
    );
};

export default FullPageLoader;
